export default "__VITE_ASSET__ByxIklzI__"